// Rajasthan Tour Packages Data
export const rajasthanPackages = [
  {
    id: 1,
    tripId: 'RAJ-002',
    title: 'Gems of Rajasthan | Fortresses to Desert Dunes',
    duration: '5 Nights / 6 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-15 People',
    image: '/images/packages/1.jpg',
    link: '#gems-rajasthan',
    category: 'Heritage Tours',
    highlights: ['Jaipur Hawa Mahal & Amber Fort', 'Jodhpur Mehrangarh Fort', 'Jaisalmer Golden Fort', 'Camel Safari in Thar Desert'],
    itinerary: 'Jaipur-Jodhpur-Jaisalmer-Jodhpur',
    inclusions: ['Heritage Hotels', 'Desert Camp', 'Camel Safari', 'Cultural Performances', 'All Transfers'],
    bestFor: 'Heritage lovers and adventure seekers',
    detailedPackage: {
      overview: "Discover the magnificent fortresses and golden desert dunes of Rajasthan in this 6-day adventure. From Jaipur's pink palaces to Jodhpur's blue city and Jaisalmer's golden fort, experience the royal heritage of Rajputana. Enjoy camel safaris in the Thar Desert, stay in heritage hotels, and witness mesmerizing cultural performances under starlit skies.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Jaipur | The Pink City Welcome",
          description: "Arrive in Jaipur and check into your heritage hotel. After refreshments, visit the iconic Hawa Mahal (Palace of Winds) and take photos of its intricate lattice work. Explore the nearby bazaars of Johari and Bapu for traditional Rajasthani handicrafts, jewelry, and textiles. Evening at leisure to experience the vibrant atmosphere of the Pink City. Overnight stay in Jaipur."
        },
        {
          day: 2,
          title: "Jaipur Exploration | Amber Fort and City Palace",
          description: "After breakfast, visit the magnificent Amber Fort, a UNESCO World Heritage Site. Enjoy an elephant ride or jeep ride up to the fort entrance. Explore the Sheesh Mahal (Mirror Palace), Diwan-e-Khas, and other royal chambers. Visit Jaigarh Fort to see the world's largest cannon. Later, explore the City Palace complex with its museums, courtyards, and beautiful architecture. Visit Jantar Mantar astronomical observatory. Evening folk dance performance with traditional Rajasthani dinner."
        },
        {
          day: 3,
          title: "Jaipur to Jodhpur | Journey to the Blue City",
          description: "After breakfast, depart for Jodhpur (5-6 hours drive) through scenic Rajasthani countryside. Upon arrival, check into your heritage hotel. Evening visit to the local markets around Clock Tower and Sardar Market. Experience the blue-painted houses of the old city. Try local delicacies like Mirchi Vada and Mawa Kachori. Overnight stay in Jodhpur."
        },
        {
          day: 4,
          title: "Jodhpur to Jaisalmer | The Golden City",
          description: "Morning visit to the mighty Mehrangarh Fort, one of the largest forts in India. Explore its palaces, courtyards, and museums with panoramic views of the blue city. Visit Jaswant Thada, a beautiful marble cenotaph. After lunch, depart for Jaisalmer (5-6 hours drive). Arrive in the evening and check into your hotel. Rest and prepare for tomorrow's desert adventure."
        },
        {
          day: 5,
          title: "Jaisalmer Sightseeing and Desert Safari",
          description: "After breakfast, explore Jaisalmer Fort, a living fort with shops, hotels, and residences. Visit Patwon Ki Haveli, Salim Singh Ki Haveli, and Nathmal Ki Haveli - exquisite examples of Rajasthani architecture. In the afternoon, proceed to Sam Sand Dunes for camel safari. Experience the golden sunset over the Thar Desert. Enjoy traditional Rajasthani folk music and dance performances around a bonfire. Overnight stay in desert camp under the stars."
        },
        {
          day: 6,
          title: "Jaisalmer to Jodhpur | Departure",
          description: "Early morning sunrise view over the desert dunes. After breakfast at the camp, return to Jaisalmer city. Check out and depart for Jodhpur (5-6 hours drive). Upon arrival in Jodhpur, transfer to airport/railway station for your onward journey. Tour concludes with memories of royal forts and desert adventures."
        }
      ],
      packageInfo: {
        duration: "6D/5N",
        tripType: "Road",
        startCity: "Jaipur",
        endCity: "Jodhpur",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in heritage hotels and desert camp",
        "Daily breakfast and dinner in desert camp",
        "All transfers and sightseeing by air-conditioned vehicle",
        "Camel safari at Sam Sand Dunes",
        "Cultural folk dance and music performances",
        "All monument entrance fees",
        "Professional guide services",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare/train fare to Jaipur and from Jodhpur",
        "Lunch except at desert camp",
        "Personal expenses and tips",
        "Travel insurance",
        "Any fees at monuments",
        "Any item not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Desert Camp", "Sightseeing", "Transfer", "Meals", "Safari"]
    }
  },
  {
    id: 2,
    tripId: 'RAJ-003',
    title: 'Rajasthan Heritage Odyssey | Timeless Tales',
    duration: '07 Nights / 08 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-20 People',
    image: '/images/packages/2.jpg',
    link: '#heritage-odyssey',
    category: 'Heritage Tours',
    highlights: ['Jaipur City Palace & Jantar Mantar', 'Udaipur Lake Palace & Boat Ride', 'Jodhpur Blue City Tour', 'Jaisalmer Desert Safari'],
    itinerary: 'Jaipur-Udaipur-Jodhpur-Jaisalmer-Jodhpur',
    inclusions: ['4-Star Heritage Hotels', 'Lake Pichola Boat Ride', 'Desert Camping', 'Folk Dance Shows', 'All Meals'],
    bestFor: 'Luxury heritage experience seekers',
    detailedPackage: {
      overview: "Embark on a comprehensive 8-day heritage odyssey through Rajasthan's most magnificent destinations. Experience the grandeur of royal palaces, serene lakes, majestic forts, and golden deserts. This luxury heritage tour combines comfort with culture, offering stays in premium heritage hotels, romantic boat rides, desert camping, and authentic cultural experiences.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Jaipur | Royal Welcome",
          description: "Arrive in Jaipur and check into your heritage hotel. Welcome drink and traditional aarti ceremony. Evening orientation tour of the city including a visit to local markets like Johari Bazaar for jewelry and Bapu Bazaar for textiles. Enjoy welcome dinner with live folk music performance. Overnight stay in Jaipur."
        },
        {
          day: 2,
          title: "Jaipur City Tour | Pink City Exploration",
          description: "After breakfast, visit the magnificent Amber Fort with elephant/jeep ride. Explore the Sheesh Mahal and royal chambers. Visit Jaigarh Fort and see the world's largest cannon. Afternoon visit to City Palace complex, Jantar Mantar astronomical observatory, and photo stop at Hawa Mahal. Evening shopping and leisure time. Traditional Rajasthani dinner with cultural show."
        },
        {
          day: 3,
          title: "Jaipur to Udaipur | Journey to City of Lakes",
          description: "After breakfast, depart for Udaipur (6-7 hours drive) via Nathdwara. En route visit Nathdwara Temple dedicated to Lord Krishna. Continue to Udaipur and check into your heritage hotel. Evening leisure walk around Fateh Sagar Lake. Dinner at hotel with views of the illuminated City Palace."
        },
        {
          day: 4,
          title: "Udaipur Sightseeing | Venice of the East",
          description: "Morning visit to City Palace, the largest palace complex in Rajasthan with stunning architecture and lake views. Visit Jagdish Temple and Saheliyon ki Bari (Garden of Maidens). Afternoon boat ride on Lake Pichola with views of Lake Palace and Jag Mandir. Visit local art galleries and handicraft shops. Evening sunset viewing from Monsoon Palace."
        },
        {
          day: 5,
          title: "Udaipur to Jodhpur | Blue City Bound",
          description: "After breakfast, depart for Jodhpur (4-5 hours drive). En route visit Ranakpur Jain Temples, famous for their intricate marble carvings and 1,444 uniquely carved pillars. Continue to Jodhpur and check into your heritage hotel. Evening explore the blue-painted houses of the old city and Clock Tower market."
        },
        {
          day: 6,
          title: "Jodhpur to Jaisalmer | Golden City Adventure",
          description: "Morning visit to Mehrangarh Fort, one of India's largest forts with panoramic views of the blue city. Explore its palaces, museums, and courtyards. Visit Jaswant Thada marble cenotaph. After lunch, depart for Jaisalmer (5-6 hours drive). Evening arrival and check into hotel. Rest and preparation for desert experience."
        },
        {
          day: 7,
          title: "Jaisalmer Fort and Desert Safari",
          description: "Morning exploration of Jaisalmer Fort, a living fort with narrow lanes, shops, and havelis. Visit Patwon Ki Haveli, Salim Singh Ki Haveli, and Nathmal Ki Haveli. Afternoon proceed to Sam Sand Dunes for camel safari and jeep safari. Watch spectacular sunset over Thar Desert. Evening cultural program with folk dance, music, and traditional dinner around bonfire. Overnight stay in luxury desert camp."
        },
        {
          day: 8,
          title: "Jaisalmer to Jodhpur | Departure",
          description: "Early morning sunrise view over sand dunes. After breakfast, return to Jaisalmer city. Visit local markets for shopping souvenirs like camel leather goods, mirror work textiles, and jewelry. Depart for Jodhpur (5-6 hours drive). Transfer to airport/railway station for departure. Tour concludes with cherished memories of Rajasthan's heritage."
        }
      ],
      packageInfo: {
        duration: "8D/7N",
        tripType: "Road",
        startCity: "Jaipur",
        endCity: "Jodhpur",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in 4-star heritage hotels and luxury desert camp",
        "All meals (breakfast, lunch, dinner)",
        "Air-conditioned vehicle for all transfers and sightseeing",
        "Professional English-speaking guide",
        "Boat ride on Lake Pichola",
        "Camel safari and jeep safari in desert",
        "Cultural folk performances",
        "All monument entrance fees",
        "Welcome and farewell ceremonies",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare/train fare to Jaipur and from Jodhpur",
        "Personal expenses and shopping",
        "Tips and gratuities",
        "Travel insurance",
        "Any fees at monuments",
        "Any item not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Desert Camp", "Sightseeing", "Transfer", "Meals", "Guide", "Boat Ride"]
    }
  },
  {
    id: 3,
    tripId: 'RAJ-004',
    title: 'Royal Romance | Rajasthan Honeymoon Special',
    duration: '05 Nights / 06 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-8 People',
    image: '/images/packages/3.jpg',
    link: '#royal-romance',
    category: 'Honeymoon Tours',
    highlights: ['Udaipur Lake Pichola Boat Ride', 'Jodhpur Mehrangarh Fort', 'Jaisalmer Candle Light Dinner', 'Desert Dune Bashing'],
    itinerary: 'Udaipur-Jodhpur-Jaisalmer',
    inclusions: ['4-Star Hotels', 'Candle Light Dinner', 'Romantic Boat Ride', 'Desert Camp', 'Honeymoon Amenities'],
    bestFor: 'Newly married couples seeking romantic getaway',
    detailedPackage: {
      overview: "Experience the romance of Rajasthan with this specially curated honeymoon package. From the romantic lakes of Udaipur to the majestic forts of Jodhpur and the golden dunes of Jaisalmer, create unforgettable memories with your loved one. Enjoy private boat rides, candlelight dinners, luxury accommodations, and romantic experiences amidst royal heritage.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Udaipur | City of Lakes Welcome",
          description: "Arrive in Udaipur and receive a traditional welcome with flower garlands and tilaka. Check into your romantic heritage hotel with lake views. Welcome drink and honeymoon amenities including flower bed decoration and fruit basket. Evening private boat ride on Lake Pichola with champagne and snacks, watching the sunset with views of City Palace and Lake Palace. Romantic dinner at hotel's rooftop restaurant."
        },
        {
          day: 2,
          title: "Udaipur Romance | Palaces and Gardens",
          description: "After leisurely breakfast, visit the magnificent City Palace with its romantic courtyards and stunning lake views. Explore Jagdish Temple and Saheliyon ki Bari (Garden of Maidens). Afternoon couple spa session (optional). Visit local markets for jewelry and handicrafts. Evening visit to Monsoon Palace for panoramic sunset views. Romantic candlelight dinner at lakeside restaurant with live music."
        },
        {
          day: 3,
          title: "Udaipur to Jodhpur | Blue City Romance",
          description: "After breakfast, depart for Jodhpur (4-5 hours drive) with scenic stops for photography. Check into your heritage hotel in Jodhpur. Evening romantic walk through the blue-painted old city lanes. Visit Clock Tower market for shopping. Dinner at hotel with traditional Rajasthani cuisine and folk music performance."
        },
        {
          day: 4,
          title: "Jodhpur to Jaisalmer | Golden Desert Romance",
          description: "Morning visit to the magnificent Mehrangarh Fort with panoramic views of the blue city. Explore royal chambers and museum. Visit Jaswant Thada marble cenotaph. After lunch, depart for Jaisalmer (5-6 hours drive). Evening arrival and check into hotel. Romantic dinner at hotel with views of the golden fort."
        },
        {
          day: 5,
          title: "Jaisalmer Desert Romance | Golden Memories",
          description: "Morning exploration of Jaisalmer Fort and its romantic havelis - Patwon Ki Haveli and Nathmal Ki Haveli. Afternoon proceed to Sam Sand Dunes for romantic camel safari during sunset. Check into luxury desert camp with private tent. Evening romantic setup with bonfire, traditional folk dance and music performance. Special candlelight dinner under the stars in the desert."
        },
        {
          day: 6,
          title: "Jaisalmer Departure | Farewell to Romance",
          description: "Early morning sunrise viewing over the golden dunes - perfect for romantic photography. After breakfast at camp, return to Jaisalmer city. Visit local markets for shopping souvenirs and traditional items. Check out from hotel and transfer to airport/railway station for departure. Tour concludes with a collection of romantic memories."
        }
      ],
      packageInfo: {
        duration: "6D/5N",
        tripType: "Road",
        startCity: "Udaipur",
        endCity: "Jaisalmer",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in romantic heritage hotels and luxury desert camp",
        "Daily breakfast and romantic dinners",
        "Honeymoon amenities - flower decorations, fruit basket, welcome drink",
        "Private boat ride on Lake Pichola with champagne",
        "Camel safari in Thar Desert",
        "Candlelight dinner under stars in desert",
        "All transfers in air-conditioned vehicle",
        "Professional guide services",
        "Cultural folk performances",
        "All monument entrance fees",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare/train fare to Udaipur and from Jaisalmer",
        "Lunch except mentioned",
        "Personal expenses and shopping",
        "Spa treatments (optional)",
        "Tips and gratuities",
        "Travel insurance",
        "Any fees at monuments",
        "Any item not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Desert Camp", "Sightseeing", "Transfer", "Meals", "Boat Ride", "Romance"]
    }
  },
  {
    id: 4,
    tripId: 'RAJ-005',
    title: 'Ranthambore Wildlife & Rajasthan Forts',
    duration: '06 Nights / 07 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-12 People',
    image: '/images/packages/4.jpg',
    link: '#rajasthan-wildlife',
    category: 'Wildlife Tours',
    highlights: ['Tiger Safari Ranthambore', 'Jaipur Amber Fort', 'Bharatpur Bird Sanctuary', 'Wildlife Photography'],
    itinerary: 'Jaipur-Ranthambore-Bharatpur-Agra-Delhi',
    inclusions: ['Wildlife Lodges', '4 Safari Drives', 'Naturalist Guide', 'All Meals', 'Transportation'],
    bestFor: 'Wildlife enthusiasts and photographers',
    detailedPackage: {
      overview: "Combine Rajasthan's royal heritage with its incredible wildlife on this 7-day adventure. Experience thrilling tiger safaris in Ranthambore National Park, explore magnificent forts, visit the famous bird sanctuary at Bharatpur, and discover the rich biodiversity of Rajasthan. Perfect for nature lovers and photography enthusiasts seeking both wildlife and cultural experiences.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Jaipur | Pink City Introduction",
          description: "Arrive in Jaipur and check into your hotel. After refreshments, visit the iconic Hawa Mahal and City Palace for an introduction to Rajasthani architecture. Evening briefing about the wildlife tour and equipment check for safari photography. Dinner at hotel with traditional Rajasthani cuisine."
        },
        {
          day: 2,
          title: "Jaipur Sightseeing and Transfer to Ranthambore",
          description: "Early morning visit to Amber Fort with elephant ride. Explore the magnificent palaces and enjoy panoramic views. Visit Jaigarh Fort to see the world's largest cannon. After lunch, depart for Ranthambore (3-4 hours drive). Check into wildlife lodge. Evening nature walk around the lodge premises. Briefing by naturalist about Ranthambore's wildlife and safari guidelines."
        },
        {
          day: 3,
          title: "Ranthambore Tiger Safari | Morning and Evening",
          description: "Early morning tiger safari in Ranthambore National Park (6:30 AM - 10:00 AM). Ranthambore is famous for its tiger population and offers excellent chances of tiger sightings. Spot various wildlife including leopards, sloth bears, hyenas, jackals, and over 300 bird species. Return to lodge for breakfast and rest. Afternoon safari (2:30 PM - 6:00 PM) exploring different zones of the park. Evening sharing experiences and wildlife photography review."
        },
        {
          day: 4,
          title: "Ranthambore to Bharatpur | Bird Paradise",
          description: "Early morning final safari in Ranthambore. After breakfast, depart for Bharatpur (4-5 hours drive). Check into hotel near Keoladeo National Park. Evening visit to Bharatpur Bird Sanctuary, a UNESCO World Heritage Site. Cycle rickshaw ride through the park to spot various migratory and resident birds including painted storks, herons, ibises, and if lucky, the rare Siberian cranes."
        },
        {
          day: 5,
          title: "Bharatpur to Agra via Fatehpur Sikri",
          description: "Early morning bird watching walk in Keoladeo National Park with ornithologist guide. After breakfast, depart for Agra via Fatehpur Sikri. Visit the magnificent Fatehpur Sikri, the deserted Mughal capital. Continue to Agra and check into hotel. Evening visit to Mehtab Bagh for sunset views of the Taj Mahal. Dinner at hotel."
        },
        {
          day: 6,
          title: "Agra Sightseeing and Delhi Transfer",
          description: "Early morning visit to the magnificent Taj Mahal during sunrise - perfect for photography. Return to hotel for breakfast. Visit Agra Fort, a red sandstone fort with beautiful Mughal architecture. After lunch, depart for Delhi (3-4 hours drive). Check into hotel in Delhi. Evening free for shopping at Connaught Place or Khan Market."
        },
        {
          day: 7,
          title: "Delhi Sightseeing and Departure",
          description: "After breakfast, visit India Gate, Raj Ghat, and drive past important government buildings. Visit Qutub Minar and Humayun's Tomb. Afternoon visit to National Museum or Red Fort (time permitting). Final wildlife photography session review and certificate presentation. Transfer to airport for departure. Tour concludes with memories of royal heritage and incredible wildlife."
        }
      ],
      packageInfo: {
        duration: "7D/6N",
        tripType: "Road",
        startCity: "Jaipur",
        endCity: "Delhi",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in wildlife lodges and heritage hotels",
        "All meals (breakfast, lunch, dinner)",
        "4 wildlife safaris in Ranthambore National Park",
        "Entry to Bharatpur Bird Sanctuary with rickshaw ride",
        "Professional naturalist and bird watching guide",
        "Air-conditioned vehicle for all transfers",
        "All monument entrance fees",
        "Wildlife photography guidance",
        "Binoculars during safaris and bird watching",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare to Jaipur and from Delhi",
        "Personal expenses and tips",
        "Any fees at monuments",
        "Professional photography equipment rental",
        "Travel insurance",
        "Any item not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Wildlife Lodge", "Sightseeing", "Safari", "Transfer", "Meals", "Guide"]
    }
  },
  {
    id: 5,
    tripId: 'RAJ-007',
    title: 'Khatu Shyamji Spiritual Pilgrimage Tour',
    duration: '02 Days / 01 Night',
    groupSize: '2-15 People',
    image: '/images/packages/5.jpg',
    link: 'package-details',
    category: 'Pilgrimage Tours',
    highlights: ['Khatu Shyamji Temple', 'Salasar Balaji', 'Spiritual Atmosphere', 'Temple Markets'],
    itinerary: 'Delhi-Sikar-Khatu-Salasar-Delhi',
    inclusions: ['Accommodation', 'Breakfast', 'AC Transportation', 'Temple Visits'],
    bestFor: 'Spiritual devotees and pilgrims',
    detailedPackage: {
      overview: "Visit the two most revered pilgrimage sites of Rajasthan with our 2-day Khatu Shyamji tour package and immerse yourself in spirituality. Experience the fervent devotion of pilgrims and feel the energetic atmosphere echoing with the hymns and Jaikara of Shyamji. We have carefully created our tour package considering our guests' comfort and safety. The tour begins from Delhi with a road trip to Sikar. You will visit the Khatu Shyamji Temple and Salasar Balaji. This enriching journey will leave you with lasting memories.",
      itineraryDetails: [
        {
          day: 1,
          title: "Delhi - Sikar - Khatu",
          description: "Morning arrival in Delhi, you will be picked up by the tour representative of Kalyan Travels. He will receive and greet you and drive you directly to Sikar in Rajasthan. The drive will take approximately 5-6 hours. On arrival in Sikar, check into the pre-booked hotel. Freshen up and proceed to Khatu, where you will visit the Khatu Shyamji Temple. Witness the vibrant and energetic atmosphere at the temple and seek blessings. Explore the market surrounding the temple. Our driver will drive you back to the hotel in Sikar for dinner and an overnight stay."
        },
        {
          day: 2,
          title: "Sikar - Salasar Balaji - Delhi",
          description: "Have your breakfast in the hotel and check out. Our tour representative will drive you to Salasar Balaji. Upon arrival, visit the temple and seek blessings. This temple is dedicated to Lord Hanuman. It is believed that your Darshan to Khatu Shyamji is incomplete until you visit Salasar Balaji. After this, the Kalyan Travels tour representative will drive you back to Delhi and drop you off at the airport or railway station."
        }
      ],
      packageInfo: {
        duration: "2D/1N",
        tripType: "Road/Rail",
        startCity: "Delhi",
        endCity: "Delhi",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation using Starting Room Category of Each Hotel on Twin Sharing Basis",
        "Daily Breakfast as per the above package in the hotel",
        "Airport Transfers & sightseeing as per the itinerary by Air-Conditioned Sedan or MUV/SUV 04-06 Guests/Similar with an ALL INDIA TOURIST PERMIT",
        "All currently applicable taxes, however, any other tax as and when levied by the Government shall be extra"
      ],
      excludes: [
        "Any meal unless specified above",
        "Any Air fare",
        "Any Guide",
        "Any Jungle Safari",
        "All entrance fees to monuments",
        "Personal nature expenses like laundry bills etc.",
        "Airport tax and travel insurance etc.",
        "Services not specified above"
      ],
      services: ["Hotel", "Sightseeing", "Transfer", "Meals"]
    }
  },
  {
    id: 6,
    tripId: 'RAJ-008',
    title: 'Grand Heritage Tour of Rajasthan',
    duration: '08 Nights / 09 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-16 People',
    image: '/images/packages/6.jpg',
    link: '#grand-rajasthan',
    category: 'Heritage Tours',
    highlights: ['Jaipur Hawa Mahal & City Palace', 'Bikaner Camel Breeding Farm', 'Jaisalmer Desert Camp Stay', 'Udaipur Lake Palace Views'],
    itinerary: 'Jaipur-Bikaner-Jaisalmer-Jodhpur-Udaipur',
    inclusions: ['3-4 Star Hotels', 'Desert Camping', 'Camel Safari', 'Folk Dance Shows', 'All Sightseeing'],
    bestFor: 'Complete Rajasthan experience seekers',
    detailedPackage: {
      overview: "Experience the complete grandeur of Rajasthan in this comprehensive 9-day tour covering five magnificent cities. From the Pink City of Jaipur to the Desert Capital of Bikaner, the Golden City of Jaisalmer, the Blue City of Jodhpur, and the Lake City of Udaipur. This grand tour offers the perfect blend of royal heritage, desert adventures, cultural experiences, and architectural marvels.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Jaipur | Pink City Welcome",
          description: "Arrive in Jaipur and check into your heritage hotel. After refreshments, evening orientation tour of the Pink City including visit to local markets like Bapu Bazaar and Johri Bazaar. Experience the vibrant culture and shop for traditional Rajasthani handicrafts, jewelry, and textiles. Welcome dinner with traditional folk music performance."
        },
        {
          day: 2,
          title: "Jaipur Sightseeing | Royal Heritage",
          description: "Morning visit to the magnificent Amber Fort with elephant ride. Explore the Sheesh Mahal, Diwan-e-Khas, and royal chambers. Visit Jaigarh Fort to see the world's largest cannon. Afternoon sightseeing includes City Palace complex, Jantar Mantar astronomical observatory, and photo stop at iconic Hawa Mahal. Evening leisure time for shopping."
        },
        {
          day: 3,
          title: "Jaipur to Bikaner | Camel Country",
          description: "After breakfast, depart for Bikaner (5-6 hours drive) through the Thar Desert landscape. Check into hotel upon arrival. Evening visit to the local markets and Kote Gate area. Experience the unique culture of the desert city. Dinner at hotel with traditional Rajasthani cuisine."
        },
        {
          day: 4,
          title: "Bikaner Exploration | Desert Fortress",
          description: "Morning visit to the impressive Junagarh Fort, one of the few unconquered forts in Rajasthan. Explore its beautiful palaces and museums. Visit the famous Karni Mata Temple (Rat Temple) at Deshnoke. Afternoon visit to the National Research Centre on Camel to learn about camel breeding and research. Evening camel cart ride in the countryside."
        },
        {
          day: 5,
          title: "Bikaner to Jaisalmer | Golden Journey",
          description: "After breakfast, depart for Jaisalmer (5-6 hours drive) through the heart of the Thar Desert. Arrive in the evening and check into hotel. First glimpse of the magnificent Golden Fort illuminated in the evening. Rest and prepare for tomorrow's desert adventure."
        },
        {
          day: 6,
          title: "Jaisalmer Sightseeing and Desert Safari",
          description: "Morning exploration of Jaisalmer Fort, a living UNESCO World Heritage Site. Visit the exquisite havelis - Patwon Ki Haveli, Salim Singh Ki Haveli, and Nathmal Ki Haveli. Afternoon proceed to Sam Sand Dunes for camel safari and jeep ride. Experience spectacular sunset over the Thar Desert. Evening cultural program with folk dance, music, and traditional dinner at desert camp under starlit sky."
        },
        {
          day: 7,
          title: "Jaisalmer to Jodhpur | Blue City Bound",
          description: "Early morning sunrise viewing over sand dunes. After breakfast, depart for Jodhpur (5-6 hours drive). En route visit to rural villages to experience authentic desert life. Arrive in Jodhpur and check into heritage hotel. Evening walk through the blue-painted streets of the old city and visit Clock Tower market."
        },
        {
          day: 8,
          title: "Jodhpur to Udaipur | Lake City",
          description: "Morning visit to the mighty Mehrangarh Fort with panoramic views of the blue city. Explore its magnificent palaces, museums, and ramparts. Visit Jaswant Thada marble cenotaph. After lunch, depart for Udaipur (4-5 hours drive). Evening arrival and check into lake-facing heritage hotel. Boat ride on Lake Pichola with sunset views."
        },
        {
          day: 9,
          title: "Udaipur Sightseeing and Departure",
          description: "Morning visit to the magnificent City Palace, the largest palace complex in Rajasthan. Explore Jagdish Temple and Saheliyon ki Bari (Garden of Maidens). Visit local art galleries and handicraft shops. Afternoon departure transfer to airport/railway station. Tour concludes with memories of complete Rajasthan experience."
        }
      ],
      packageInfo: {
        duration: "9D/8N",
        tripType: "Road",
        startCity: "Jaipur",
        endCity: "Udaipur",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in heritage and desert hotels",
        "Daily breakfast and dinner at desert camp",
        "Air-conditioned vehicle for all transfers and sightseeing",
        "Camel safari and jeep ride in Thar Desert",
        "Boat ride on Lake Pichola",
        "Cultural folk performances in desert",
        "Elephant ride at Amber Fort",
        "Professional guide services",
        "All monument entrance fees",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare to Jaipur and from Udaipur",
        "Lunch except at desert camp",
        "Personal expenses and shopping",
        "Travel insurance",
        "Any fees at monuments",
        "Tips and gratuities",
        "Any item not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Desert Camp", "Sightseeing", "Transfer", "Meals", "Safari", "Cultural Shows"]
    }
  },
  {
    id: 7,
    tripId: 'RAJ-009',
    title: 'Desert Circuit | Thar Desert Explorer',
    duration: '07 Nights / 08 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-15 People',
    image: '/images/packages/7.jpg',
    link: '#desert-circuit',
    category: 'Desert Tours',
    highlights: ['Jaipur Pink City Tour', 'Bikaner Camel Research Centre', 'Jaisalmer Living Fort', 'Pushkar Holy Lake'],
    itinerary: 'Jaipur-Bikaner-Jaisalmer-Jodhpur-Ajmer-Pushkar-Jaipur',
    inclusions: ['Heritage Hotels', 'Desert Camping', 'Camel Safari', 'All Transfers', 'Cultural Shows'],
    bestFor: 'Desert culture and heritage enthusiasts',
    detailedPackage: {
      overview: "Explore the mystifying stories of the Thar Desert with this comprehensive circuit tour. Experience the desert lifestyle, magnificent forts, and vibrant culture of Rajasthan's desert cities. From Jaipur's royal heritage to Bikaner's camel culture, Jaisalmer's golden dunes, and the spiritual essence of Pushkar, this tour offers diverse desert experiences.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Jaipur | Pink City Introduction",
          description: "Arrive in Jaipur and transfer to heritage hotel. Evening visit to Hawa Mahal and local markets for introduction to Rajasthani culture. Traditional welcome dinner with folk music performance."
        },
        {
          day: 2,
          title: "Jaipur to Bikaner | Desert Journey Begins",
          description: "Morning visit to Amber Fort with elephant ride. Explore City Palace and Jantar Mantar. Afternoon departure for Bikaner through desert landscape. Evening arrival and check into heritage hotel."
        },
        {
          day: 3,
          title: "Bikaner Desert Culture | Camel Capital",
          description: "Visit Junagarh Fort and its magnificent palaces. Explore National Research Centre on Camel and learn about desert life. Visit Karni Mata Temple. Evening camel cart ride through desert villages."
        },
        {
          day: 4,
          title: "Bikaner to Jaisalmer | Golden Destination",
          description: "Morning departure for Jaisalmer through Thar Desert. Afternoon arrival and check into hotel. Evening exploration of Jaisalmer Fort and its narrow lanes with shops and havelis."
        },
        {
          day: 5,
          title: "Jaisalmer Desert Experience | Sam Dunes Safari",
          description: "Morning sightseeing of havelis - Patwon Ki, Salim Singh Ki, and Nathmal Ki Haveli. Afternoon camel safari at Sam Sand Dunes. Desert camping with cultural performances and traditional dinner under stars."
        },
        {
          day: 6,
          title: "Jaisalmer to Jodhpur via Desert Route",
          description: "Early morning sunrise over dunes. Return to city and depart for Jodhpur. Visit Mehrangarh Fort and Jaswant Thada. Evening exploration of blue city streets and local markets."
        },
        {
          day: 7,
          title: "Jodhpur to Pushkar via Ajmer | Spiritual Journey",
          description: "Morning departure for Ajmer. Visit Ajmer Sharif Dargah, one of India's most important Sufi shrines. Continue to Pushkar, the holy city. Visit Brahma Temple and enjoy evening aarti at Pushkar Lake."
        },
        {
          day: 8,
          title: "Pushkar to Jaipur | Departure",
          description: "Morning boat ride on Pushkar Lake and visit to local temples. Departure for Jaipur. Transfer to airport/railway station for onward journey."
        }
      ],
      packageInfo: {
        duration: "8D/7N",
        tripType: "Road",
        startCity: "Jaipur",
        endCity: "Jaipur",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in heritage hotels and desert camp",
        "Daily breakfast and meals at desert camp",
        "Air-conditioned vehicle for all transfers",
        "Camel safari and desert camping",
        "Cultural folk performances",
        "Professional guide services",
        "All monument entrance fees",
        "Boat ride at Pushkar Lake",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare/train fare",
        "Lunch except mentioned",
        "Personal expenses",
        "Travel insurance",
        "Any ticket feair or fees",
        "Tips and gratuities",
        "Items not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Desert Camp", "Sightseeing", "Transfer", "Meals", "Safari"]
    }
  },
  {
    id: 8,
    tripId: 'RAJ-010',
    title: 'Pearls of Rajasthan | Royal Triangle',
    duration: '06 Nights / 07 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-15 People',
    image: '/images/packages/8.jpg',
    link: '#pearls-rajasthan',
    category: 'Heritage Tours',
    highlights: ['Jaipur City Palace & Amber Fort', 'Jodhpur Mehrangarh Fort Views', 'Udaipur Lake Palace & Boat Ride', 'Traditional Handicraft Shopping'],
    itinerary: 'Jaipur-Jodhpur-Udaipur-Jaipur',
    inclusions: ['Heritage Hotels', 'Lake Boat Ride', 'Cultural Shows', 'All Sightseeing', 'Professional Guide'],
    bestFor: 'First-time visitors seeking royal heritage',
    detailedPackage: {
      overview: "Discover the three pearls of Rajasthan - Jaipur, Jodhpur, and Udaipur. This tour showcases the finest royal heritage, magnificent palaces, and timeless architecture. Experience the Pink City's royal grandeur, the Blue City's fortress majesty, and the Lake City's romantic charm in this perfectly crafted heritage circuit.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Jaipur | Pink City Welcome",
          description: "Airport/railway station transfer to heritage hotel. Evening free for shopping at local markets. Traditional welcome dinner with cultural performance."
        },
        {
          day: 2,
          title: "Jaipur Royal Heritage | Palaces and Forts",
          description: "Morning visit to Amber Fort with elephant ride. Explore Sheesh Mahal and royal chambers. Afternoon sightseeing includes City Palace, Jantar Mantar, and Hawa Mahal photo stop. Evening leisure time."
        },
        {
          day: 3,
          title: "Jaipur to Jodhpur | Blue City Journey",
          description: "Morning departure for Jodhpur (5-6 hours drive). Check into heritage hotel upon arrival. Evening orientation walk through blue-painted old city streets and Clock Tower market."
        },
        {
          day: 4,
          title: "Jodhpur to Udaipur | City of Lakes",
          description: "Morning visit to magnificent Mehrangarh Fort with panoramic blue city views. Explore Umaid Bhawan Palace museum. Afternoon departure for Udaipur via Ranakpur (en route visit to Jain temples). Evening arrival and check into lake-facing hotel."
        },
        {
          day: 5,
          title: "Udaipur Lake City | Palaces and Gardens",
          description: "Morning visit to City Palace, the largest palace complex in Rajasthan. Explore Jagdish Temple and Saheliyon ki Bari. Afternoon boat ride on Lake Pichola with views of Lake Palace and Jag Mandir. Evening sunset viewing from Monsoon Palace."
        },
        {
          day: 6,
          title: "Udaipur to Jaipur | Return Journey",
          description: "Morning at leisure for shopping at local handicraft markets. Afternoon departure for Jaipur (6-7 hours drive). Evening arrival and check into hotel. Farewell dinner with cultural show."
        },
        {
          day: 7,
          title: "Jaipur Departure | Final Shopping",
          description: "Morning visit to local handicraft centers for final shopping. Transfer to airport/railway station for departure. Tour concludes with royal memories."
        }
      ],
      packageInfo: {
        duration: "7D/6N",
        tripType: "Road",
        startCity: "Jaipur",
        endCity: "Jaipur",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in heritage hotels",
        "Daily breakfast and dinner",
        "Air-conditioned vehicle for all transfers",
        "Boat ride on Lake Pichola",
        "Elephant ride at Amber Fort",
        "Professional English-speaking guide",
        "Cultural folk performances",
        "All monument entrance fees",
        "Welcome and farewell ceremonies",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare/train fare",
        "Lunch except mentioned",
        "Personal expenses and shopping",
        "Travel insurance",
        "Any fees at monuments",
        "Tips and gratuities",
        "Items not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Sightseeing", "Transfer", "Meals", "Guide", "Boat Ride"]
    }
  },
  {
    id: 9,
    tripId: 'RAJ-001',
    title: 'Golden Triangle with Rajasthan Classic',
    duration: '05 Nights / 06 Days',
    price: 'On Request',
    priceNote: 'Per Person',
    groupSize: '2-15 People',
    image: '/images/packages/9.jpg',
    link: '#golden-triangle-rajasthan',
    category: 'Cultural Tours',
    highlights: ['Delhi Red Fort & India Gate', 'Agra Taj Mahal & Fort', 'Jaipur Amber Fort & Hawa Mahal', 'City Palace Jaipur'],
    itinerary: 'Delhi-Agra-Jaipur-Delhi',
    inclusions: ['3-Star Hotels', 'Breakfast', 'AC Transportation', 'Guide', 'Monuments Entry'],
    bestFor: 'First-time visitors to Rajasthan & Golden Triangle',
    detailedPackage: {
      overview: "Experience the best of India's Golden Triangle combined with Rajasthan's royal heritage in this 6-day classic tour. This journey takes you through Delhi's historic monuments, Agra's magnificent Taj Mahal, and Jaipur's royal palaces and forts. Discover the rich Mughal and Rajput heritage, marvel at architectural wonders, and immerse yourself in the vibrant culture of North India.",
      itineraryDetails: [
        {
          day: 1,
          title: "Arrival in Delhi | Welcome to India's Capital",
          description: "Arrive at Indira Gandhi International Airport, Delhi. Meet our representative and transfer to your hotel. After check-in and refreshments, embark on a tour of Old Delhi. Visit the magnificent Red Fort, a UNESCO World Heritage Site, and explore the bustling lanes of Chandni Chowk. Experience a rickshaw ride through the narrow bylanes and savor delicious street food. Visit Jama Masjid, one of India's largest mosques. Return to hotel for overnight stay."
        },
        {
          day: 2,
          title: "Delhi Sightseeing | Exploring New Delhi",
          description: "After breakfast, proceed for New Delhi sightseeing. Visit India Gate, a war memorial dedicated to Indian soldiers. Drive past President House (Rashtrapati Bhavan) and Parliament House. Visit Qutub Minar, a 73-meter high victory tower and UNESCO World Heritage Site. Explore Humayun's Tomb, a precursor to the Taj Mahal. Visit Lotus Temple, known for its distinctive lotus flower shape. Evening free for shopping at Connaught Place or Khan Market."
        },
        {
          day: 3,
          title: "Delhi to Agra | City of the Taj Mahal",
          description: "Early morning departure for Agra via Yamuna Expressway (3-4 hours drive). On arrival, check into your hotel. After lunch, visit the magnificent Taj Mahal, one of the Seven Wonders of the World. Marvel at this symbol of eternal love built by Emperor Shah Jahan for his beloved wife Mumtaz Mahal. Later visit Agra Fort, a red sandstone fort with beautiful palaces and gardens. Evening at leisure to explore local markets."
        },
        {
          day: 4,
          title: "Agra to Jaipur via Fatehpur Sikri | Journey to Pink City",
          description: "After breakfast, depart for Jaipur. En route, visit Fatehpur Sikri, the deserted Mughal capital built by Emperor Akbar. Explore the Buland Darwaza (Gate of Victory), Jama Masjid, and the tomb of Salim Chishti. Continue journey to Jaipur (4-5 hours drive). Check into your hotel upon arrival. Evening free to explore local markets like Bapu Bazaar and Johri Bazaar."
        },
        {
          day: 5,
          title: "Jaipur Sightseeing | Exploring the Pink City",
          description: "After breakfast, visit the majestic Amber Fort, located on a hilltop. Enjoy an elephant ride or jeep ride to the fort entrance. Explore the Sheesh Mahal (Mirror Palace) and other beautiful palaces within the fort. Visit Jaigarh Fort to see the world's largest cannon on wheels. Later, visit City Palace, a beautiful blend of Rajasthani and Mughal architecture. Explore Jantar Mantar, an astronomical observatory and UNESCO World Heritage Site. Stop for photos at the iconic Hawa Mahal (Palace of Winds). Evening cultural show with dinner."
        },
        {
          day: 6,
          title: "Jaipur to Delhi | Departure",
          description: "After breakfast, check out from the hotel. If time permits, visit local handicraft centers to shop for souvenirs, textiles, jewelry, and pottery. Depart for Delhi (5-6 hours drive). Upon arrival in Delhi, transfer to the airport or railway station for your onward journey. Tour concludes with beautiful memories of Golden Triangle and Rajasthan."
        }
      ],
      packageInfo: {
        duration: "6D/5N",
        tripType: "Road",
        startCity: "Delhi",
        endCity: "Delhi",
        price: "On Request",
        priceNote: "Per Person"
      },
      includes: [
        "Accommodation in well-appointed hotels on twin sharing basis",
        "Daily breakfast at the hotel",
        "All transfers and sightseeing by air-conditioned vehicle",
        "Professional English-speaking guide",
        "All monument entrance fees as per itinerary",
        "Elephant/Jeep ride at Amber Fort",
        "All currently applicable taxes"
      ],
      excludes: [
        "Airfare/train fare to and from Delhi",
        "Lunch and dinner unless specified",
        "Personal expenses like laundry, telephone, tips, etc.",
        "Travel insurance",
        "Any fees at monuments",
        "Any item not mentioned in inclusions",
        "GST as applicable"
      ],
      services: ["Hotel", "Sightseeing", "Transfer", "Meals", "Guide"]
    }
  }
];

export const destinations = [
  { 
    id: 1, 
    title: 'Jaipur', 
    image: '/images/destinations/jaipur.jpg',
    description: 'The Pink City of Rajasthan, known for its royal palaces and vibrant culture.',
    highlights: ['Amber Fort', 'City Palace', 'Hawa Mahal', 'Jantar Mantar'],
    bestTime: 'October to March',
    category: 'Royal Heritage',
    nickname: 'Pink City'
  },
  { 
    id: 2, 
    title: 'Udaipur', 
    image: '/images/destinations/udaipur.jpg',
    description: 'The City of Lakes, famous for its romantic palaces and beautiful lakes.',
    highlights: ['City Palace', 'Lake Pichola', 'Jag Mandir', 'Saheliyon ki Bari'],
    bestTime: 'October to March',
    category: 'Royal Heritage',
    nickname: 'City of Lakes'
  },
  {
    id: 3,
    title: 'Jodhpur',
    image: '/images/destinations/jodhpur.jpg',
    description: 'The Blue City, gateway to the Thar Desert with magnificent forts.',
    highlights: ['Mehrangarh Fort', 'Jaswant Thada', 'Clock Tower', 'Blue City Streets'],
    bestTime: 'October to March',
    category: 'Desert Heritage',
    nickname: 'Blue City'
  },
  {
    id: 4,
    title: 'Jaisalmer',
    image: '/images/destinations/jaisalmer.jpg',
    description: 'The Golden City in the heart of Thar Desert, famous for golden sandstone architecture.',
    highlights: ['Jaisalmer Fort', 'Sam Sand Dunes', 'Patwon Ki Haveli', 'Desert Safari'],
    bestTime: 'October to February',
    category: 'Desert Heritage',
    nickname: 'Golden City'
  },
  {
    id: 5,
    title: 'Kumbalgarh',
    image: '/images/destinations/kumbalgarh.jpg',
    description: 'Famous for its massive fort and stunning views of the Aravalli Range.',
    highlights: ['Kumbalgarh Fort', 'Badal Mahal', 'Vijay Stambha', 'Kumbhalgarh Wildlife Sanctuary'],
    bestTime: 'October to March',
    category: 'Spiritual & Cultural',
    nickname: 'Rose Garden of Rajasthan'
  },
  {
    id:6,
    title: 'Pushkar',
    image: '/images/destinations/pushkar.jpg',
    description: 'Holy city with the famous Brahma Temple and sacred Pushkar Lake.',
    highlights: ['Brahma Temple', 'Pushkar Lake', 'Camel Fair', 'Savitri Temple'],
    bestTime: 'October to March',
    category: 'Spiritual & Cultural',
    nickname: 'Rose Garden of Rajasthan'
  },
  {
    id: 7,
    title: 'Bikaner',
    image: '/images/destinations/bikaner.jpg',
    description: 'Desert city famous for camel breeding, sweets, and magnificent palaces.',
    highlights: ['Junagarh Fort', 'Camel Research Centre', 'Karni Mata Temple', 'Lalgarh Palace'],
    bestTime: 'October to February',
    category: 'Desert Heritage',
    nickname: 'Camel Country'
  },
  {
    id: 8,
    title: 'Mount Abu',
    image: '/images/destinations/mount-abu.jpg',
    description: 'The only hill station in Rajasthan, known for Dilwara Jain Temples.',
    highlights: ['Dilwara Temples', 'Nakki Lake', 'Guru Shikhar', 'Sunset Point'],
    bestTime: 'October to March',
    category: 'Hill Station',
    nickname: 'Oasis in the Desert'
  },
  {
    id: 9,
    title: 'Ranthambore',
    image: '/images/destinations/ranthambore.jpg',
    description: 'Famous national park known for tiger sightings and historic fort.',
    highlights: ['Tiger Safari', 'Ranthambore Fort', 'Padam Talao', 'Wildlife Photography'],
    bestTime: 'October to June',
    category: 'Wildlife',
    nickname: 'Land of Tigers'
  },
  {
    id: 10,
    title: 'Ajmer',
    image: '/images/destinations/ajmer.jpg',
    description: 'Pilgrimage city home to the famous Ajmer Sharif Dargah.',
    highlights: ['Ajmer Sharif Dargah', 'Ana Sagar Lake', 'Adhai Din Ka Jhonpra', 'Taragarh Fort'],
    bestTime: 'October to March',
    category: 'Spiritual',
    nickname: 'Heart of Rajasthan'
  },
  {
    id: 11,
    title: 'Chittorgarh',
    image: '/images/destinations/chittorgarh.jpg',
    description: 'Historic city with the largest fort in India and tales of valor.',
    highlights: ['Chittorgarh Fort', 'Vijay Stambh', 'Padmini Palace', 'Kalika Mata Temple'],
    bestTime: 'October to March',
    category: 'Historical',
    nickname: 'City of Pride'
  }
];

export const specialtyTours = [
  { 
    id: 1, 
    title: 'Desert Safari', 
    image: '/images/desert-safari.jpg',
    description: 'Experience the golden sands of Thar Desert with camel safaris and camping',
    destinations: ['Jaisalmer', 'Bikaner', 'Jodhpur', 'Pushkar']
  },
  { 
    id: 2, 
    title: 'Palace Tours', 
    image: '/images/palace-tours.jpg',
    description: 'Explore magnificent palaces and experience royal hospitality',
    destinations: ['Udaipur', 'Jaipur', 'Jodhpur', 'Jaisalmer']
  },
  { 
    id: 3, 
    title: 'Pilgrimage Tours', 
    image: '/images/pilgrimage-rajasthan.jpg',
    description: 'Visit sacred temples and holy sites across Rajasthan',
    destinations: ['Ajmer', 'Pushkar', 'Mount Abu', 'Bikaner']
  },
  { 
    id: 4, 
    title: 'Village Tours', 
    image: '/images/village-tours.jpg',
    description: 'Experience authentic rural life and traditional Rajasthani culture',
    destinations: ['Mandawa', 'Samode', 'Osiyan', 'Rohet']
  },
  {
    id: 5,
    title: 'Fort & Heritage',
    image: '/images/fort-heritage.jpg',
    description: 'Discover the valor and history of Rajasthan through its magnificent forts',
    destinations: ['Mehrangarh', 'Amber', 'Jaisalmer', 'Chittorgarh']
  },
  {
    id: 6,
    title: 'Camel Safari',
    image: '/images/camel-safari.jpg',
    description: 'Traditional camel journeys through the desert landscapes',
    destinations: ['Jaisalmer', 'Bikaner', 'Pushkar', 'Jodhpur']
  }
];

// Experience Categories inspired by Travel Rajasthan
export const experienceCategories = [
  {
    id: 0,
    title: 'Royal Events',
    icon: '👑',
    description: 'Organize your events and celebrations like royalty in Rajasthan',
    image: '/images/experiences/royal-events.jpg',
    destinations: ['Jaipur', 'Udaipur', 'Jodhpur'],
    link: '#royal-events'
  },
  {
    id: 1,
    title: 'Forts and Palaces',
    icon: '🏰',
    description: 'Explore magnificent forts and royal palaces showcasing India\'s royal heritage',
    image: '/images/experiences/forts.jpg',
    destinations: ['Amber Fort', 'Chittorgarh Fort', 'Kumbalgarh Fort'],
    link: '#forts-palaces'
  },
  {
    id: 2,
    title: 'Art & Culture',
    icon: '🎭',
    description: 'Immerse yourself in India\'s diverse art forms and cultural traditions',
    image: '/images/experiences/culture.jpg',
    destinations: ['Folk Dances', 'Local Crafts', 'Music Performances', 'Festivals'],
    link: '#art-culture'
  },
  {
    id: 3,
    title: 'Museums',
    icon: '🏛️',
    description: 'Discover India\'s history through world-class museums and galleries',
    image: '/images/experiences/museums.jpg',
    destinations: ['City Palace Museum', 'Albert Hall', 'Crafts Museum'],
    link: '#museums'
  },
  {
    id: 4,
    title: 'Temples',
    icon: '🛕',
    description: 'Visit sacred temples and experience spiritual India',
    image: '/images/experiences/temples.jpg',
    destinations: ['Salasar Balaji', 'Khatu Shyam Ji', 'Jagatpita Shri Brahma Mandir'],
    link: '#temples'
  },
  {
    id: 5,
    title: 'Wildlife',
    icon: '🐅',
    description: 'Encounter India\'s diverse wildlife in natural habitats',
    image: '/images/experiences/wildlife.jpg',
    destinations: ['Tiger Reserves', 'Bird Sanctuaries', 'Safari Tours'],
    link: '#wildlife'
  },
  {
    id: 6,
    title: 'Recreation & Leisure',
    icon: '🏖️',
    description: 'Relax and rejuvenate with leisure activities and spa treatments',
    image: '/images/experiences/leisure.jpg',
    destinations: ['Desert Resorts', 'Hill Stations', 'Luxury Hotels'],
    link: '#recreation'
  },
  {
    id: 7,
    title: 'Fairs and Festivals',
    icon: '🎪',
    description: 'Participate in colorful festivals and traditional fairs',
    image: '/images/experiences/festivals.jpg',
    destinations: ['Pushkar Mela', 'Teej', 'Desert Festival'],
    link: '#festivals'
  },
  {
    id: 8,
    title: 'Jain Temples',
    icon: '☸️',
    description: 'Explore the intricate architecture and spiritual significance of Jain temples',
    image: '/images/experiences/adventure.jpg',
    destinations: ['Dilwara Temples', 'Ranakpur Temple', 'Mahaveer Ji Temple'],
    link: '#jain-temples'
  }
];

export const blogs = [
  {
    id: 1,
    title: 'Bhangarh Fort: The Cursed Fort of Alwar',
    category: 'Mysteries',
    excerpt: 'Explore the most haunted fort in India where entry is forbidden after sunset. Legend tells of a cursed magician named Singhia who doomed this 17th-century fort and all its inhabitants to eternal darkness...',
    date: 'October 20, 2025',
    image: '/images/mysteries/1.jpg',
    link: '#bhangarh-mystery'
  },
  {
    id: 2,
    title: 'Kuldhara Village: The Vanished Civilization',
    category: 'Mysteries',
    excerpt: 'Discover the ghost village near Jaisalmer where 1,300 people vanished overnight in the 19th century. The Paliwal Brahmins cursed this land, ensuring no one would ever settle here again...',
    date: 'October 18, 2025',
    image: '/images/mysteries/2.jpg',
    link: '#kuldhara-mystery'
  },
  {
    id: 3,
    title: 'Om Banna Temple: The Motorcycle God',
    category: 'Mysteries',
    excerpt: 'Discover the miraculous temple of Bullet Baba where a Royal Enfield motorcycle is worshipped and whiskey is an offering. Legend tells of Om Singh Rathore who died in an accident, and his bike that refuses to stay away from the crash site, protecting travelers on the highway...',
    date: 'October 4, 2025',
    image: '/images/mysteries/9.jpg',
    link: '#ombanna-mystery'
  },
  {
    id: 4,
    title: 'Sudhabay: The Ghost Fair of Pushkar',
    category: 'Mysteries',
    excerpt: 'Witness the mysterious Ghost Fair near Pushkar where exorcism rituals cleanse people of evil spirits. This sacred site hosts supernatural ceremonies that draw believers from across the country...',
    date: 'October 8, 2025',
    image: '/images/mysteries/7.jpg',
    link: '#sudhabay-mystery'
  },
  {
    id: 5,
    title: 'Chand Baori: The Stepwell of Spirits',
    category: 'Mysteries',
    excerpt: 'Explore the ancient stepwell with 3,500 steps built mysteriously in one night by spirits. This architectural marvel in Abhaneri is said to be haunted by souls of those who died during construction...',
    date: 'October 12, 2025',
    image: '/images/mysteries/5.jpg',
    link: '#chandbaori-mystery'
  },
  {
    id: 6,
    title: 'Brij Raj Bhawan: The British Ghost of Kota',
    category: 'Mysteries',
    excerpt: 'Meet the spirit of Major Charles Burton who still guards this heritage hotel. Killed during the 1857 rebellion, his ghost in British attire continues to patrol the premises of this Kota palace...',
    date: 'October 10, 2025',
    image: '/images/mysteries/6.jpg',
    link: '#brijraj-mystery'
  },
  {
    id: 7,
    title: 'Nahargarh Fort: The Restless Prince',
    category: 'Mysteries',
    excerpt: 'Uncover the story of Prince Nahar Singh Bhomia whose spirit disrupted construction until a temple was built in his honor. Even today, visitors experience ghostly encounters in this Jaipur fort...',
    date: 'October 14, 2025',
    image: '/images/mysteries/4.jpg',
    link: '#nahargarh-mystery'
  },
  {
    id: 8,
    title: 'Jagatpura: The Witch\'s Town of Jaipur',
    category: 'Mysteries',
    excerpt: 'Enter the haunted residential area of Jaipur where locals report encounters with witches in white robes. Strange whispers, floating apparitions, and malevolent presences make this place truly terrifying...',
    date: 'October 6, 2025',
    image: '/images/mysteries/8.jpg',
    link: '#jagatpura-mystery'
  },
  {
    id: 9,
    title: 'Rana Kumbha Palace: Echoes of Jauhar',
    category: 'Mysteries',
    excerpt: 'Step into Chittorgarh Palace where Rani Padmini performed Jauhar to escape capture. Visitors report hearing cries and screams, and seeing women in royal dresses wandering the halls...',
    date: 'October 16, 2025',
    image: '/images/mysteries/3.jpg',
    link: '#chittorgarh-mystery'
  }
];
